define('plugin/paid-events/model/PaymentSystemModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Payment system model
     *
     * @class PaymentSystemModel
     */
    return BaseModel.extend({

        defaults: {
            id: '',
            payment_system: '',
            name: '',
            selected: false,
            recurring: false
        }

    });

});
